// extracted by mini-css-extract-plugin
export default {"contactSortColumnIcon":"FQOvgRKwGTMLeLDqRcOq"};